import cx from "classnames";
import { CueIcon } from "common/CueIcon";
import { commonCTAs, commonNouns, commonVerbs, Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import Select from "react-select";
import styles from "./CueForm.scss";

class TypeValue extends React.PureComponent {
  render() {
    const { value } = this.props.value;
    return (
      <div className={"Select-value"} title={this.props.value.title}>
        <span className={"Select-value-label"}>
          <CueIcon type={value} className={styles.directionIcon} />
          {this.props.children}
        </span>
      </div>
    );
  }
}

class TypeOption extends React.PureComponent {
  handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  };
  handleMouseEnter = (event) => {
    this.props.onFocus(this.props.option, event);
  };
  handleMouseMove = (event) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  };
  render() {
    const { value } = this.props.option;
    return (
      <div
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <CueIcon type={value} className={styles.directionIcon} />
        {this.props.children}
      </div>
    );
  }
}

export class CueForm extends React.PureComponent {
  constructor(props) {
    super(props);

    const { type, notes, description, deleted } = this.props.currentCue;

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      type: type,
      notes: notes,
      description: description,
      deleted: deleted,
    };
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // eslint-disable-line
    this.setState({
      type: nextProps.currentCue.type,
      notes: nextProps.currentCue.notes,
      description: nextProps.currentCue.description,
      deleted: nextProps.currentCue.deleted,
    });
  }

  render() {
    const { onConfirm, onPrevious, onDelete } = this.props;
    const { type, notes, description, deleted } = this.state;

    const cueTypes =
      window.T &&
      Object.entries(window.T.t("cuesheet_types")).map(([a, b]) => ({
        value: a,
        label: b,
      }));

    return (
      <div className={styles.CueForm}>
        <p>
          <T id="CueForm.confirmCue" defaultMessage="Confirm that the type, cue, and notes are correct." />
        </p>

        <label htmlFor={"cue_type"}>
          <T id="CueForm.type" defaultMessage="Type" />
        </label>
        <Select
          value={type}
          options={cueTypes}
          name={"type"}
          onChange={(type) => this.setState({ type: type.value })}
          clearable={false}
          valueComponent={TypeValue}
          optionComponent={TypeOption}
        />

        <label htmlFor={"cue_notes"}>
          <T id="CueForm.notes" defaultMessage="Notes" />
        </label>
        <textarea
          id={"cue_notes"}
          name={"notes"}
          value={notes}
          onChange={this.handleChange}
          disabled={deleted}
          className={cx(deleted && styles.disabledField)}
        />

        <label htmlFor={"cue_description"}>
          <Msg capitalized m={commonNouns.description} />
        </label>
        <textarea
          id={"cue_description"}
          name={"description"}
          value={description}
          onChange={this.handleChange}
          disabled={deleted}
          className={cx(deleted && styles.disabledField)}
        />

        <div className={styles.actionRow}>
          <a className={cx(styles.button, styles.grey)} onClick={onPrevious}>
            <Msg capitalized m={commonCTAs.previous} />
          </a>
          {deleted ? (
            <a className={styles.button} onClick={() => onDelete(this.state, false)}>
              <T id="CueForm.undelete" defaultMessage="Undelete" />
            </a>
          ) : (
            <a className={styles.button} onClick={() => onDelete(this.state)}>
              <Msg m={commonVerbs.delete} />
            </a>
          )}
          <a className={cx(styles.button, styles.CTA)} onClick={() => onConfirm(this.state)}>
            <Msg m={commonCTAs.confirm} />
          </a>
        </div>
      </div>
    );
  }
}
